import { render } from "./ForgetPasswordPage.vue?vue&type=template&id=aac2cb0c&ts=true"
import script from "./ForgetPasswordPage.vue?vue&type=script&lang=ts"
export * from "./ForgetPasswordPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Authentication/ForgetPasswordPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "aac2cb0c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('aac2cb0c', __exports__)) {
    api.reload('aac2cb0c', __exports__)
  }
  
  module.hot.accept("./ForgetPasswordPage.vue?vue&type=template&id=aac2cb0c&ts=true", () => {
    api.rerender('aac2cb0c', render)
  })

}


export default __exports__